import Link from "next/link";

import { Anchor, Button } from "@newsela/angelou";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";

interface HomePageLinkButtonProps {
  title?: string;
  children?: React.ReactNode;
}

const HomePageLinkButton: React.FC<HomePageLinkButtonProps> = ({
  children,
}: HomePageLinkButtonProps) => {
  return (
    <Link href={MONOLITH_ORIGIN} passHref legacyBehavior>
      <Anchor
        styleAnchorAsButton={{
          /* AUTOGENERATED TODO: update angelou to new flavor.
            see https://github.com/newsela/angelou/blob/main/src/components/Button/README.md#MIGRATION
            for migration guide. */
          legacy_flavor: Button.legacy_flavor.solid,
          legacy_size: Button.legacy_size.medium,
          legacy_statusColor: Button.legacy_statusColor.primary,
        }}
      >
        {children}
      </Anchor>
    </Link>
  );
};

export default HomePageLinkButton;
